/**
 * @function createUploadFormData
 * @summary create upload data using FormData interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/FormData
 * @param {Object} files - upload files
 * @since 0.1.0
 * @returns {Object} formData - new FormData Object
 */
export function createUploadFormData(files) {
  const formData = new FormData();
  const fileNames = Object.keys(files);

  for (let index = 0, n = fileNames.length; index < n; index += 1) {
    const fileName = fileNames[index];
    const file = files[fileName];
    formData.append(fileName, file);
  }

  return formData;
}

/**
 *
 * @param files
 * @returns {{type: *}[]}
 */
export function transformFiles(files) {
  return Object.keys(files).map(item => ({ ...files[item], ...{ type: item } }));
}
